import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';
import theme from '../theme';

function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleSubmit = async () => {
    if (!email || !password) {
      setMessage('Inserisci email e password!');
      return;
    }
    setLoading(true);
    setMessage('');
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) setMessage('Email o password errati.');
    setLoading(false);
  };

  return (
    <div style={{ maxWidth: theme.layout.maxWidth, margin: '0 auto', fontFamily: theme.font.family }}>
      <div style={{ background: theme.colors.primary, padding: '40px 20px', color: theme.colors.white, textAlign: 'center' }}>
        <h1 style={{ margin: 0, fontSize: theme.font.size.hero }}>Jobbetty</h1>
        <p style={{ margin: '8px 0 0', opacity: 0.85, fontSize: theme.font.size.lg }}>Trova lavoretti vicino a te</p>
      </div>

      <div style={{ padding: '30px 20px' }}>
        <h2 style={{ marginBottom: theme.spacing.xxl, color: theme.colors.textPrimary }}>Accedi</h2>

        <div style={{ marginBottom: theme.spacing.lg }}>
          <label style={{ fontSize: theme.font.size.base, color: theme.colors.textSecondary, display: 'block', marginBottom: 6 }}>Email</label>
          <input type="email" value={email} onChange={e => setEmail(e.target.value)}
            placeholder="la@tua.email"
            style={{ width: '100%', padding: '12px', borderRadius: theme.radius.sm, border: `1px solid ${theme.colors.borderInput}`, fontSize: theme.font.size.lg, boxSizing: 'border-box' }}
          />
        </div>

        <div style={{ marginBottom: theme.spacing.xxl }}>
          <label style={{ fontSize: theme.font.size.base, color: theme.colors.textSecondary, display: 'block', marginBottom: 6 }}>Password</label>
          <input type="password" value={password} onChange={e => setPassword(e.target.value)}
            placeholder="••••••••"
            style={{ width: '100%', padding: '12px', borderRadius: theme.radius.sm, border: `1px solid ${theme.colors.borderInput}`, fontSize: theme.font.size.lg, boxSizing: 'border-box' }}
          />
        </div>

        {message && (
          <div style={{ background: theme.colors.errorBg, color: theme.colors.errorDark, padding: 12, borderRadius: theme.radius.sm, marginBottom: theme.spacing.lg, fontSize: theme.font.size.md }}>
            {message}
          </div>
        )}

        <button onClick={handleSubmit} disabled={loading} style={{
          width: '100%', background: loading ? theme.colors.textMuted : theme.colors.primary, color: theme.colors.white,
          border: 'none', borderRadius: theme.radius.lg, padding: 14,
          fontSize: theme.font.size.xl, cursor: loading ? 'not-allowed' : 'pointer', marginBottom: theme.spacing.lg
        }}>{loading ? 'Caricamento...' : 'Accedi'}</button>

        <p style={{ textAlign: 'center', color: theme.colors.textSecondary, fontSize: theme.font.size.md }}>
          Non hai un account?{' '}
          <span onClick={() => navigate('/register')}
            style={{ color: theme.colors.primary, cursor: 'pointer', fontWeight: 600 }}>
            Registrati
          </span>
        </p>
      </div>
    </div>
  );
}

export default Login;